import Service from "../../services";

const state = {
  switchLanguage: "th",
  feeds: [],
  isShowLanding: false,
};

const getters = {};

const actions = {
  setLanguage({ commit }, val) {
    commit("SET_LANGUAGE", val);
  },
  getImageLanding({ commit }) {
    return Service.Common.getImageLanding().then((res) => {
      return res;
    });
  },
  getMainImageLanding({ commit }) {
    return Service.Common.getMainImageLanding().then((res) => {
      commit("setImageLanding", res);
      return res;
    });
  },
  getGroupCategory({ commit }) {
    return Service.Common.getGroupCategory().then((res) => {
      return res;
    });
  },
};

const mutations = {
  SET_LANGUAGE: (state, val) => {
    state.switchLanguage = val;
  },
  setImageLanding: (state, res) => {
    var date = new Date();
    var month = pad2(date.getMonth() + 1); //months (0-11)
    var day = pad2(date.getDate()); //day (1-31)
    var year = date.getFullYear();
    var dateNow = year + "-" + month + "-" + day;
    if (
      res.start_date &&
      res.end_date &&
      dateNow >= res.start_date &&
      dateNow <= res.end_date
    ) {
      state.isShowLanding = true;
    } else {
      state.isShowLanding = false;
    }
  },
  setFeeds: (state, val) => {
    state.feeds = val;
  },
};

function pad2(n) {
  return (n < 10 ? "0" : "") + n;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
